import { DEVICE_SIZES, SIZE_KEYS } from '../constans/styles';

type TSizeKeys = typeof SIZE_KEYS[number];

type TDeviceSizes = 'desktop' | 'mobile' | 'tablet';

interface IBreakpoints {
  min: Record<TDeviceSizes, string>;
  max: Record<TDeviceSizes, string>;
}

type TSpacing = Record<TSizeKeys, string>;

const BREAKPOINTS: IBreakpoints = {
  min: {
    mobile: `(min-width: ${DEVICE_SIZES.MOBILE})`,
    tablet: `(min-width: ${DEVICE_SIZES.TABLET})`,
    desktop: `(min-width: ${DEVICE_SIZES.DESKTOP})`,
  },
  max: {
    mobile: `(max-width: ${DEVICE_SIZES.MOBILE})`,
    tablet: `(max-width: ${DEVICE_SIZES.TABLET})`,
    desktop: `(max-width: ${DEVICE_SIZES.DESKTOP})`,
  },
};

const SPACING: TSpacing = {
  piko: '2px',
  nano: '4px',
  mikro: '8px',
  mili: '12px',
  centy: '16px',
  decy: '24px',
  deka: '32px',
  hekto: '40px',
  mega: '48px',
  giga: '64px',
  tera: '80px',
  peta: '96px',
  eksa: '160px',
};

export const LAYOUT = {
  breakpoints: BREAKPOINTS,
  spacing: SPACING,
} as const;
